// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2_NPD","inputWrap":"CustomTip_inputWrap__2YeMw"};